import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const IntegrationAccordion = ({ title, children, defaultOpen = false, badge }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-gray-100 rounded-md p-4">
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center gap-3">
          <KeyboardArrowDownIcon
            fontSize="small"
            className={`text-gray-600 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          />
          <span className="ml-2 text-lg font-semibold text-gray-800">{title}</span>
          {badge && (
            <span className={`px-3 py-1 rounded-full text-xs font-semibold ${badge.className}`}>
              {badge.text}
            </span>
          )}
        </div>
      </div>

      {isOpen && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          {children}
        </div>
      )}
    </div>
  );
};

export default IntegrationAccordion;

